/*eslint-disable*/
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import estateLogo from ".././../assets/img/EstateMind.jpg";
import NotificationDropdown from "components/Dropdowns/NotificationDropdown.js";
import UserDropdown from "components/Dropdowns/UserDropdown.js";
import { FaHeadset } from "react-icons/fa";
import { MdSupportAgent } from "react-icons/md";
import { getCookie } from "cookies-next";

export default function Sidebar() {
  const [collapseShow, setCollapseShow] = useState("hidden");
  const location = useLocation();
  const [userRole, setUserRole] = useState(null);

  // Retrieve user role from localStorage
  useEffect(() => {
    const storedRole = getCookie("user");
    setUserRole(storedRole); // Set the user role state
    console.log('storedRole: ', storedRole);
  }, []);

  return (
    <>
      <nav className="md:left-0  md:block md:fixed md:top-0 md:bottom-0 md:overflow-y-auto md:flex-row md:flex-nowrap md:overflow-hidden shadow-xl bg-white flex flex-wrap items-center justify-between relative md:w-64 z-10 py-4 px-6 ">
        <div className="md:flex-col md:items-stretch md:min-h-full md:flex-nowrap px-0 flex flex-wrap items-center justify-between w-full mx-auto">
          {/* Toggler */}
          <button
            className="cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
            type="button"
            onClick={() => setCollapseShow("bg-white m-2 py-3 px-6")}
          >
            <i className="fas fa-bars"></i>
          </button>
          {/* Brand */}
          <ul className="md:hidden items-center flex flex-wrap list-none ">
            <li className="inline-block relative">
              <NotificationDropdown />
            </li>
            <li className="inline-block relative">
              <UserDropdown />
            </li>
          </ul>
          {/* Collapse */}
          <div
            className={
              "md:flex md:flex-col pt-9 md:items-stretch md:opacity-100 md:relative md:mt-4 md:shadow-none shadow absolute top-0 left-0 right-0 z-40 overflow-y-auto overflow-x-hidden h-auto items-center flex-1 rounded " +
              collapseShow
            }
          >
            <img src={estateLogo} alt="logo" className="" />
            <hr className="my-4 md:min-w-full" />

            {/* Navigation */}
            <ul className="md:flex-col md:min-w-full flex flex-col list-none">
              <li className="items-center">
                <Link
                  className={
                    "text-xs uppercase py-3 font-bold block " +
                    (location.pathname === "/admin/worker"
                      ? "text-lightBlue-500 hover:text-lightBlue-600"
                      : "text-blueGray-700 hover:text-blueGray-500")
                  }
                  to="/admin/worker"
                >
                  <i
                    className={
                      "fas fa-tv mr-2 text-sm " +
                      (location.pathname === "/admin/worker"
                        ? "opacity-75"
                        : "text-blueGray-300")
                    }
                  ></i>{" "}
                   Chatbot
                </Link>
              </li>

              {/* Conditionally Render "Create Team Lead" */}
              {userRole !== "team_lead" && userRole !== "agent" && (
                <>
                <li className="items-center">
                  <Link
                    className={
                      "text-xs uppercase py-3 font-bold block " +
                      (location.pathname === "/team-lead"
                        ? "text-lightBlue-500 hover:text-lightBlue-600"
                        : "text-blueGray-700 hover:text-blueGray-500")
                    }
                    to="/team-lead"
                  >
                    <i
                      className={
                        "fas fa-users-cog mr-2 text-sm " +
                        (location.pathname === "/team-lead"
                          ? "opacity-75"
                          : "text-blueGray-300")
                      }
                    ></i>{" "}
                     Team Lead
                  </Link>
                </li>
                 <li className="items-center flex">
                 <Link
                   className={
                     "text-xs uppercase py-3 font-bold  flex " +
                     (location.pathname === "/agent"
                       ? "text-lightBlue-500 hover:text-lightBlue-600"
                       : "text-blueGray-700 hover:text-blueGray-500")
                   }
                   to="/agent"
                 >
                   <MdSupportAgent
                     size={20}
                     className={
                       "mr-2 text-sm " +
                       (location.pathname === "/agent"
                         ? "text-lightBlue-500 opacity-75"
                         : "text-blueGray-300")
                     }
                   />
                    Agent
                 </Link>
               </li>
               {/* <li className="items-center flex">
                 <Link
                   className={
                     "text-xs uppercase py-3 font-bold  flex " +
                     (location.pathname === "/history"
                       ? "text-lightBlue-500 hover:text-lightBlue-600"
                       : "text-blueGray-700 hover:text-blueGray-500")
                   }
                   to="/history"
                 >
                   <i
                      className={
                        "fas fa-users-cog mr-2 text-sm " +
                        (location.pathname === "/team-lead"
                          ? "opacity-75"
                          : "text-blueGray-300")
                      }
                    ></i>{" "}
                    History
                 </Link>
               </li> */}
               </>
              )}

              {userRole === "team_lead" && (
                <li className="items-center flex">
                  <Link
                    className={
                      "text-xs uppercase py-3 font-bold  flex " +
                      (location.pathname === "/agent"
                        ? "text-lightBlue-500 hover:text-lightBlue-600"
                        : "text-blueGray-700 hover:text-blueGray-500")
                    }
                    to="/agent"
                  >
                    <MdSupportAgent
                      size={20}
                      className={
                        "mr-2 text-sm " +
                        (location.pathname === "/agent"
                          ? "text-lightBlue-500 opacity-75"
                          : "text-blueGray-300")
                      }
                    />
                     Agent
                  </Link>
                </li>
              )}
              <li className="items-center">
                <Link
                  className={
                    "text-xs uppercase py-3 font-bold block " +
                    (location.pathname === "/admin/leads"
                      ? "text-lightBlue-500 hover:text-lightBlue-600"
                      : "text-blueGray-700 hover:text-blueGray-500")
                  }
                  to="/admin/leads"
                >
                  <i
                    className={
                      "fas fa-tools mr-2 text-sm " +
                      (location.pathname === "/admin/leads"
                        ? "opacity-75"
                        : "text-blueGray-300")
                    }
                  ></i>{" "}
                  Leads
                </Link>
              </li>

              <li className="items-center">
                <Link
                  className={
                    "text-xs uppercase py-3 font-bold block " +
                    (location.pathname === "/admin/chats"
                      ? "text-lightBlue-500 hover:text-lightBlue-600"
                      : "text-blueGray-700 hover:text-blueGray-500")
                  }
                  to="/admin/chats"
                >
                  <i
                    className={
                      "fas fa-table mr-2 text-sm " +
                      (location.pathname === "/admin/chats"
                        ? "opacity-75"
                        : "text-blueGray-300")
                    }
                  ></i>{" "}
                  Chats
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}
